// Der Gang einer Figur als Anzeigewert: Aus der Strecke, die sie im Bild zurückgelegt hat, wird
// der Pendelwinkel für Arme und Beine. Reine Rechnung ohne Three.js, damit sie geprüft werden
// kann; `avatarModel.ts` und `arms.ts` hängen ihre Glieder daran.
//
// Warum aus der gezeichneten Strecke und nicht aus der Zeit: So passen die Schritte zum Boden und
// nicht zur Bildrate – dieselbe Regel wie beim Beinpendel der Kuh (ADR 0014), dessen Kurve
// (`legSwing`) hier auch benutzt wird. Im Spielzustand liegt davon nichts (Architektur-Regel 1).

import { legSwing } from './animals.js';

/** Ab dieser Geschwindigkeit in Blöcken je Sekunde gilt eine Bewegung als Gehen. */
export const GEH_SCHWELLE = 0.5;

export interface Gang {
  /**
   * Nimmt die gezeichnete Position (Fußpunkt) und die Zeit seit dem letzten Bild und liefert den
   * Pendelwinkel im Bogenmaß. Der erste Aufruf setzt nur den Ausgangspunkt.
   */
  schritt(x: number, z: number, dt: number): number;
}

export function createGang(): Gang {
  let letzteX: number | null = null;
  let letzteZ = 0;
  /** Strecke seit Beginn des laufenden Gangs in Blöcken; beim Stehen wieder 0. */
  let strecke = 0;
  let winkel = 0;

  return {
    schritt(x, z, dt) {
      if (letzteX === null) {
        letzteX = x;
        letzteZ = z;
        return 0;
      }
      const gelaufen = Math.hypot(x - letzteX, z - letzteZ);
      letzteX = x;
      letzteZ = z;
      // Ohne Zeitschritt (erstes Bild, angehaltener Tab) wäre die Geschwindigkeit unendlich.
      const geht = dt > 0 && gelaufen / dt > GEH_SCHWELLE;
      strecke = geht ? strecke + gelaufen : 0;
      winkel = legSwing(strecke, geht, winkel, dt);
      return winkel;
    },
  };
}
